import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import clazz from 'classnames';
import Button from '../Button';
import CloseBtn from '../CloseBtn';
import styles from './index.module.scss';
import styled from 'styled-components';
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var createRef = React.createRef, useRef = React.useRef;
/**
 *  ModalProps
 * visible: boolean;
 * title: string;
 * children?: any;
 * cancelText?: string;
 * okText?: string;
 * onOk?: React.EventHandler<any>;
 * onCancel?: React.EventHandler<any>;
 * showBTN?: boolean;
 * width?: number;
 * style?: React.CSSProperties;
 * hideCancel?: boolean;
 * theme?: 'default' | 'small';
 */ export var Modal = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(Modal, _Component);
    var _super = _createSuper(Modal);
    function Modal() {
        _classCallCheck(this, Modal);
        var _this;
        _this = _super.apply(this, arguments);
        _this.ceilRef = createRef();
        _this.containerRef = createRef();
        _this.contentClickRef = {
            current: false
        };
        _this.contentTimeoutRef = {
            current: null
        };
        _this.handleContentMouseDown = function() {
            _this.contentTimeoutRef.current && clearTimeout(_this.contentTimeoutRef.current);
            _this.contentClickRef.current = true;
        };
        _this.handleContentMouseUp = function() {
            _this.contentTimeoutRef.current = setTimeout(function() {
                _this.contentClickRef.current = false;
            });
        };
        _this.handlCeilClick = function(e) {
            var target = e.target; // https://github.com/react-component/dialog/blob/master/src/Dialog/index.tsx#L97
            if (_this.contentClickRef.current) {
                _this.contentClickRef.current = false;
            } else if (_this.ceilRef.current === target) {
                var ref, ref1;
                (ref = _this.props) === null || ref === void 0 ? void 0 : (ref1 = ref.outclick) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
                var _props = _this.props, outclick = _props.outclick, onCancel = _props.onCancel;
                if (outclick && onCancel) {
                    onCancel(e);
                }
            }
        };
        return _this;
    }
    _createClass(Modal, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, _hideTitle = _props.hideTitle, hideTitle = _hideTitle === void 0 ? false : _hideTitle, children = _props.children, cancelText = _props.cancelText, style = _props.style, okText = _props.okText, onOk = _props.onOk, onCancel = _props.onCancel, visible = _props.visible, showBTN = _props.showBTN, width = _props.width, height = _props.height, _titleStyle = _props.titleStyle, titleStyle = _titleStyle === void 0 ? {} : _titleStyle, disableConfirmButton = _props.disableConfirmButton, confirmLoading = _props.confirmLoading, showCloseButton = _props.showCloseButton, _footer = _props.footer, footer = _footer === void 0 ? null : _footer, icon = _props.icon, type = _props.type, _titleAlign = _props.titleAlign, titleAlign = _titleAlign === void 0 ? 'left' : _titleAlign;
                var show = visible ? styles.show : '';
                return(/*#__PURE__*/ _jsx("div", {
                    className: clazz([
                        styles.wrapper,
                        show,
                        'ui-font-regular',
                        'ui-txt-tip',
                        _defineProperty({}, styles.showBTN, showBTN)
                    ]),
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "".concat(styles.ceil, " ui-center"),
                        ref: this.ceilRef,
                        onClick: this.handlCeilClick,
                        children: /*#__PURE__*/ _jsxs("div", {
                            ref: this.containerRef,
                            style: _objectSpread({
                                width: width,
                                height: height
                            }, style),
                            onMouseDown: this.handleContentMouseDown,
                            onMouseUp: this.handleContentMouseUp,
                            className: "".concat(styles.container, " ").concat(show),
                            children: [
                                icon && /*#__PURE__*/ _jsx("div", {
                                    className: styles.titleIcon,
                                    children: icon
                                }),
                                !hideTitle && /*#__PURE__*/ _jsx("h5", {
                                    className: clazz([
                                        styles.title,
                                        'ui-font-regular'
                                    ]),
                                    style: _objectSpread({
                                        textAlign: titleAlign
                                    }, titleStyle),
                                    children: title
                                }),
                                showCloseButton && /*#__PURE__*/ _jsx(CloseBtn, {
                                    className: styles.closeBTN,
                                    onClick: onCancel
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "".concat(styles.content, " ").concat(showBTN ? styles.showbtn : ''),
                                    children: children
                                }),
                                showBTN ? /*#__PURE__*/ _jsxs("div", {
                                    className: styles.btnGroup,
                                    children: [
                                        !this.props.hideCancel && /*#__PURE__*/ _jsx(Button, {
                                            style: {
                                                minWidth: 96
                                            },
                                            onClick: onCancel,
                                            size: "large",
                                            className: "".concat(styles.cancelBTN),
                                            children: cancelText
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: type,
                                            loading: confirmLoading,
                                            disabled: disableConfirmButton,
                                            onClick: onOk,
                                            size: "large",
                                            style: {
                                                minWidth: 96
                                            },
                                            className: "".concat(styles.okBTN),
                                            children: okText
                                        })
                                    ]
                                }) : null,
                                footer
                            ]
                        })
                    })
                }));
            }
        }
    ]);
    return Modal;
}(React.Component);
Modal.defaultProps = {
    visible: false,
    cancelText: 'Cancel',
    okText: 'Confirm',
    width: 660,
    hideCancel: false,
    showCloseButton: true,
    style: {},
    height: 'auto',
    type: 'primary'
};
var ModalBody = styled.section.withConfig({
    displayName: "EmptyModal__ModalBody",
    componentId: "sc-19butpv-0"
})([
    "width:100%;padding-right:20px;margin-top:10px;dl{font-size:15px;dt,dd{display:inline-block;vertical-align:initial;margin-top:14px;margin-bottom:6px;}dt{width:80px;text-align:right;margin-right:40px;}dd{color:#171717;width:calc(100% - 120px);}}button{margin:32px auto 0;}"
]);
export { ModalBody };
export default Modal;
